export enum RequestActionTypes {
    SET_LAST_REQUEST = 'SET_LAST_REQUEST',
    CLEAR_LAST_REQUESTS = 'CLEAR_LAST_REQUESTS'
}
